module.exports = __webpack_public_path__ + "img/SK53060024.04c55115.png";